import { jsx as _jsx } from "react/jsx-runtime";
import MuiBox from '@mui/material/Box';
import * as React from 'react';
import { usePaletteColor } from '../theme/color-utils';
import { makeEnum } from '../utils';
export const LayoutVAlign = makeEnum('center', 'space-between', 'flex-end', 'flex-start');
export const LayoutHAlign = makeEnum('center', 'space-between', 'flex-end', 'flex-start');
export const Box = React.forwardRef((props, ref) => {
    const { padding, bgcolor: _bgcolor, borderColor: _borderColor, ownerState: _ownerState, ...muiProps } = props;
    const bgcolor = usePaletteColor(_bgcolor);
    const borderColor = usePaletteColor(_borderColor);
    const p = (() => {
        if (Array.isArray(padding)) {
            if (padding.length === 2) {
                return { py: padding[0], px: padding[1] };
            }
            if (padding.length === 3) {
                return { py: padding[0], px: padding[1], pb: padding[2] };
            }
            if (padding.length === 4) {
                return {
                    pt: padding[0],
                    pr: padding[1],
                    pb: padding[2],
                    pl: padding[3]
                };
            }
        }
        return { p: props.padding };
    })();
    return (_jsx(MuiBox, { ref: ref, "data-role": "box", ...p, ...muiProps, bgcolor: bgcolor, borderColor: borderColor }));
});
export const FlexBox = React.forwardRef((props, ref) => {
    const { stack, stretch, hAlign, vAlign, autoShrink, sx, gap, ...muiProps } = props;
    const flexBoxProps = useFlexBoxProps({
        autoShrink,
        gap,
        hAlign,
        vAlign,
        stack,
        stretch
    });
    return (_jsx(Box
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    , { 
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ref: ref, boxSizing: "border-box", sx: {
            ...sx,
            ':focus': {
                outlineWidth: 'none'
            },
            cursor: props.onClick ? 'pointer' : undefined
        }, ...flexBoxProps, ...muiProps }));
});
export function useFlexBoxProps(props) {
    const direction = {
        flexDirection: props.stack ? 'column' : 'row'
    };
    const justifyContent = {
        justifyContent: (props.stack ? props.vAlign : props.hAlign) || 'flex-start'
    };
    const alignItems = {
        alignItems: (props.stack ? props.hAlign : props.vAlign) || 'stretch'
    };
    const autoShrinkConfig = props.autoShrink
        ? ({
            minWidth: 0,
            width: '100%'
        })
        : undefined;
    const flex = {
        flex: typeof props.stretch === 'boolean'
            ? 1
            : props.stretch
                ? props.stretch
                : '0 1 auto'
    };
    const gap = { gap: props.gap ?? 0 };
    return {
        display: 'flex',
        ...autoShrinkConfig,
        ...direction,
        ...justifyContent,
        ...alignItems,
        ...flex,
        ...gap
    };
}
